import { createAction, props } from '@ngrx/store';
import { PublicAppInfo } from '@oca/web-shared';

export const GetAppInfo = createAction('[App] Get app info', props<{ appUrlName: string }>());
export const GetAppInfoSuccess = createAction('[App] Get app info Success', props<{ data: PublicAppInfo }>());
export const GetAppInfoFailure = createAction('[App] Get app info Failure', props<{ error: string }>());
